import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';

const Footer = () => {

  const currentYear = new Date().getFullYear();

  return (
    <Box className="footerComponent">
      <Typography color="textSecondary" component="h5" variant="caption" gutterBottom={false}>Copyright © {currentYear} Rehlko </Typography>
    </Box>
  );
};


export default Footer;
